// Generated by CoffeeScript 1.12.2
define('etc/branching_filter',['require','models/survey'],function(require) {
  var BranchingFilter, Survey;
  Survey = require('models/survey');
  return BranchingFilter = (function() {
    BranchingFilter.prototype.currentQuestion = null;

    BranchingFilter.prototype.model = null;

    function BranchingFilter(options) {
      window.DEBUG = false;
      this.model = options.model;
      this.model.get('questions').forEach(function(question, index) {
        return question.index = index;
      });
    }


    /**
    		filter the results of
    
    		@method filter
    		@param {Object} question
    		@param {Object} answer
    		@return {Object}
     */

    BranchingFilter.prototype.filter = function(question, answer) {
      this.currentQuestion = question;
      if (this.hasBrachingOptions(question)) {
        if (question.type === 'essay') {
          if (answer && !answer.values) {
            answer.values = [""];
          }
        }
        if (answer) {
          return this.triggerBranchingResults(question.branches, answer);
        }
      }
    };

    BranchingFilter.prototype.triggerBranchingResults = function(branches, answer) {
      var affectedQuestions;
      affectedQuestions = [];
      branches.forEach((function(_this) {
        return function(options) {
          if (_this.validateBranchingCondition(options, answer.values)) {
            return options.results.forEach(function(result) {
              var remove;
              if (window.DEBUG) {
                console.log("BRANCH (triggerBranchingResults) : Action - " + result.action + " \t Property - " + result.property + " \t Value - " + result.value);
              }
              remove = (function() {
                switch (result.property) {
                  case 'number':
                    return this.model.get('questions').filter(function(question, index) {
                      return question.index + 1 === Number(result.value);
                    });
                  case 'title':
                    return this.model.get('questions').filter(function(question) {
                      return question.title.trim() === result.value.trim();
                    });
                  case 'subtitle':
                    return this.model.get('questions').filter(function(question) {
                      return question.subtitle.trim() === result.value.trim();
                    });
                  case 'type':
                    return this.model.get('questions').filter(function(question) {
                      return question.type === result.value;
                    });
                  case 'tag':
                    return this.model.get('questions').filter(function(question) {
                      return question.meta && _.isArray(question.meta.tags) && question.meta.tags.indexOf(result.value) !== -1;
                    });
                  case 'required':
                    return this.model.get('questions').filter(function(question) {
                      return question.required;
                    });
                  case 'default':
                  case 'custom':
                    if (result.value) {
                      this.model.get('success').msg = result.value;
                    }
                    return this.model.get('questions');
                }
              }).call(_this);
              if (remove && remove.length) {
                return affectedQuestions = affectedQuestions.concat(remove);
              }
            });
          }
        };
      })(this));
      return affectedQuestions.forEach((function(_this) {
        return function(question, index) {
          if (question._id !== _this.currentQuestion._id) {
            _this.model.set('questions', _.without(_this.model.get('questions'), question));
            if (window.DEBUG) {
              return console.log("BRANCH (skipping):\n	index:\t" + index + "\n	id:\t" + question._id + "\n	title:\t" + question.title + "\n	totalRemaining:\t" + (_this.model.get('questions').length));
            }
          }
        };
      })(this));
    };


    /**
    		Validates branching options based on the branching conditions and branching quantifier (any,all)
    
    		@method validateBranchingCondition
    		@param {Object} options branching options from the question model
    		@return {Boolean} whether the branching condition is valid or not
     */

    BranchingFilter.prototype.validateBranchingCondition = function(options, answers) {
      var isValid, quantifierFunc;
      quantifierFunc = options.quantifier === 'any' ? _.some : _.every;
      if (window.DEBUG) {
        console.log("BRANCH (quantifier): " + options.quantifier + " ———————————————————————————————————————————————————————————");
      }
      return isValid = quantifierFunc(options.conditions, (function(_this) {
        return function(condition) {
          var iterator, operator, response, valid, value;
          response = condition.response;
          operator = condition.operator;
          value = condition.value;
          if (response === 'time' || response === 'date' || response === 'datetime') {
            value = new Date(value).getTime();
          }
          answers = _this.prepAnswerForValidation(response, answers);
          if (window.DEBUG) {
            console.log("BRANCH (condition): " + response + "  " + operator + "  " + value + " ———————————————————————————————————————————————————————————");
          }
          iterator = operator.indexOf('not') === -1 ? _.some : _.every;
          valid = iterator(answers, function(answer) {
            var val;
            if (window.DEBUG) {
              console.log("BRANCH (value): " + (JSON.stringify(answer)) + " ");
            }
            if (answer == null) {
              return false;
            }
            switch (operator) {
              case 'is':
                if (answer.hasOwnProperty('label') && answer.hasOwnProperty('value')) {
                  return answer.label.toString() === response.toString() && answer.value.toString() === value.toString();
                } else {
                  return answer.toString() === value.toString();
                }
                break;
              case 'is not':
                if (answer.hasOwnProperty('label') && answer.hasOwnProperty('value')) {
                  if (answer.label.toString() === response.toString()) {
                    return answer.value.toString() !== value.toString();
                  } else {
                    return true;
                  }
                } else {
                  return answer.toString() !== value.toString();
                }
                break;
              case 'begins with':
                if (answer.hasOwnProperty('label') && answer.hasOwnProperty('value')) {
                  return answer.label === response && RegExp("^(" + value + ").*", "mi").test(answer.value.trim());
                } else {
                  return RegExp("^(" + value + ").*", "mi").test(answer.trim());
                }
                break;
              case 'does not begin with':
                if (answer.hasOwnProperty('label') && answer.hasOwnProperty('value')) {
                  if (answer.label === response) {
                    return RegExp("^(?!" + value + ").*", "mi").test(answer.value.trim());
                  } else {
                    return true;
                  }
                } else {
                  return RegExp("^(?!" + value + ").*", "mi").test(answer.trim());
                }
                break;
              case 'ends with':
                if (answer.hasOwnProperty('label') && answer.hasOwnProperty('value')) {
                  return answer.label === response && RegExp(".*(" + value + ")$", "mi").test(answer.value.trim());
                } else {
                  return RegExp(".*(" + value + ")$", "mi").test(answer.trim());
                }
                break;
              case 'does not end with':
                if (answer.hasOwnProperty('label') && answer.hasOwnProperty('value')) {
                  if (answer.label === response) {
                    return !RegExp(".*(" + value + ")$", "mi").test(answer.value.trim());
                  }
                } else {
                  return !RegExp(".*(" + value + ")$", "mi").test(answer.trim());
                }
                break;
              case 'contains':
                if (answer.hasOwnProperty('label') && answer.hasOwnProperty('value')) {
                  return answer.label === response && RegExp("(" + value + ")", "mi").test(answer.value.trim());
                } else {
                  return RegExp("(" + value + ")", "mi").test(answer);
                }
                break;
              case 'does not contain':
                if (answer.hasOwnProperty('label') && answer.hasOwnProperty('value')) {
                  if (answer.label === response) {
                    return RegExp("^((?!" + value + ").)*$", "mi").test(answer.value.trim());
                  } else {
                    return true;
                  }
                } else {
                  return RegExp("^((?!" + value + ").)*$", "mi").test(answer);
                }
                break;
              case 'is greater than':
                val = answer.hasOwnProperty('value') ? answer.value : answer;
                if (answer.hasOwnProperty('value') && answer.hasOwnProperty('label') && response !== 'response') {
                  return answer.label === response && Number(val) > Number(value);
                } else {
                  return Number(val) > Number(value);
                }
                break;
              case 'is greater than or equal to':
                val = answer.hasOwnProperty('value') ? answer.value : answer;
                if (answer.hasOwnProperty('value') && answer.hasOwnProperty('label') && response !== 'response') {
                  return answer.label === response && Number(val) >= Number(value);
                } else {
                  return Number(val) >= Number(value);
                }
                break;
              case 'is less than':
                val = answer.hasOwnProperty('value') ? answer.value : answer;
                if (answer.hasOwnProperty('value') && answer.hasOwnProperty('label') && response !== 'response') {
                  return answer.label === response && Number(val) < Number(value);
                } else {
                  return Number(val) < Number(value);
                }
                break;
              case 'is less than or equal to':
                val = answer.hasOwnProperty('value') ? answer.value : answer;
                if (answer.hasOwnProperty('value') && answer.hasOwnProperty('label') && response !== 'response') {
                  return answer.label === response && Number(val) <= Number(value);
                } else {
                  return Number(val) <= Number(value);
                }
                break;
              case 'is equal to':
                val = answer.hasOwnProperty('value') ? answer.value : answer;
                if (answer.hasOwnProperty('value') && answer.hasOwnProperty('label') && response !== 'response') {
                  return answer.label === response && Number(val) === Number(value);
                } else {
                  return Number(val) === Number(value);
                }
                break;
              case 'is blank':
                answer = answer.hasOwnProperty('value') ? answer.value : answer;
                return (answer == null) || !answer.length;
              case 'is not blank':
                answer = answer.hasOwnProperty('value') ? answer.value : answer;
                return (answer != null) && answer.length;
              default:
                return false;
            }
          });
          if (window.DEBUG) {
            console.log("BRANCH (valid): ", valid);
          }
          return valid;
        };
      })(this));
    };


    /**
    		Returns answers based on response value
    
    		@method prepAnswerForValidation
    		@param {String} response quantifier String from the branching object
    		@param {Array} answers an array of answers
    		@return {Array} parsed answers array
     */

    BranchingFilter.prototype.prepAnswerForValidation = function(response, answers) {
      var total;
      answers = _.cloneDeep(answers);
      if (_.every(answers, function(answer) {
        return answer.hasOwnProperty('value') && /\.(gif|jpg|jpeg|png)$/i.test(answer.value);
      })) {
        _.each(answers, function(answer) {
          return answer.value = true;
        });
      }
      switch (response) {
        case 'total':
          if (_.isArray(answers) && answers.length && _.isPlainObject(answers[0])) {
            answers = _.map(answers, 'value');
          }
          total = _.reduce(answers, function(answer, sum) {
            return Number(answer) + Number(sum);
          });
          return [total];
        case 'average':
          if (_.isArray(answers) && answers.length && _.isPlainObject(answers[0])) {
            answers = _.map(answers, 'value');
          }
          total = _.reduce(answers, function(answer, sum) {
            return Number(answer) + Number(sum);
          });
          return [total / answers.length];
        case 'date':
        case 'time':
        case 'datetime':
          if (answers[0] && _.isFunction(answers[0].getTime)) {
            return [answers[0].getTime()];
          }
          break;
        default:
          return answers;
      }
    };


    /**
    		Flags whether a question has branching options
    
    		@method hasBrachingOptions
    		@param {Object} question question backbone model
    		@return {Boolean} whether a question has branching options or not
     */

    BranchingFilter.prototype.hasBrachingOptions = function(question) {
      return question.branches && _.every(question.branches, function(branch) {
        return branch.conditions && branch.conditions.length && branch.results && branch.results.length;
      });
    };

    return BranchingFilter;

  })();
});

